var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import Hourglass03Svg from './hourglass-03.icon.svg';
export const Hourglass03Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: Hourglass03Svg }));
_react_refresh_temp_1 = Hourglass03Icon;
$RefreshReg$(_react_refresh_temp_1, "Hourglass03Icon");
